/* import __COLOCATED_TEMPLATE__ from './admin-fullname.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();